export const humanizedDate = "D [de] MMMM [de] YYYY";
export const shortHumanizedDate = "D MMM YYYY";
